<template>
	<div class="sms">
        <template v-if="phoneNumber">
            <span>当前绑定手机号</span>
            <span>{{ phoneNumber }}</span>
        </template>
        <template v-else>
            <span>请输入手机号</span>
            <el-input v-model="inputPhoneNumber"
            placeholder="请输入手机号"></el-input>
        </template>
        <el-button
            type="text"
            v-if="timer < 1"
            @click="getVerificationCode()"
            >获取短信验证码</el-button
        >
        <el-button type="text" disabled v-else>{{ timer }}秒后重新获取</el-button>
            <span>请输入验证码</span>
            <el-input
            v-model="verifyCode"
            placeholder="请输入验证码" @keyup.enter.native="submit"
        ></el-input>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	props: {
        params: Object,
	},
	data() {
		return {
			timer: 0,
			timeHandler: null,
			inputPhoneNumber: "",
			verifyCode: "",
		};
	},
	computed: {
		...mapGetters(["userInfo"]),
		phoneNumber() {
			return this.params.phoneNumber;
		}
	},
	methods: {
		getVerificationCode() {
			let verifySendApi = this.params.verifySendApi??this.$api.loginSecverifySend;
			if (!this.phoneNumber && !/^1[3456789]\d{9}$/.test(this.inputPhoneNumber)) {
				this.$message.error("请输入正确的手机号")
				return;
			};
			let needKey = ["bit", "key"];
			let params = {};
			for(let item in this.params) {
				if (needKey.includes(item)) {
					params[item] = this.params[item];
				}
			}
			// 用户信息有手机号时不传递手机号
			if (this.params.operation === "verify") {
				if(!this.userInfo.contactInfo)
					params.contactInfo = this.phoneNumber || this.inputPhoneNumber;
			} else {
				params.contactInfo = this.phoneNumber || this.inputPhoneNumber;
			}
			
			verifySendApi({
					...params,
					types: ["sms"],
				})
				.then((response) => {
					this.setInterval();
					if (response.errcode !== 0) return;
					if (response.data === false) {
						this.overTime();
					}
				});
		},
		setInterval() {
			if (this.timeHandlers) return;
			this.timer = 60;
			this.timeHandlers = window.setInterval(() => {
				this.timer -= 1;
				if (this.timer < 1) {
					window.clearInterval(this.timeHandlers);
					this.timeHandlers = null;
				}
			}, 1000);
		},
		clearInterval() {
			if (this.timeHandlers) window.clearInterval(this.itmeHandler);
		},
		getCode() {
			return {
				...this.params,
				type: "sms",
                code: this.verifyCode,
                phoneNumber: this.phoneNumber || this.inputPhoneNumber
            }
		},
		overTime() {
			this.$emit("overTime");
		},
		submit() {
			this.$emit("submit");
		}
	},
	destroyed() {
		this.clearInterval();
	},
};
</script>

<style lang="scss" scoped>
.sms {
	font-size: 14px;
	display: grid;
	grid-template-columns: 100px 200px 20px;
    grid-row-gap: 30px;
    grid-column-gap: 20px;
	align-items: center;
}
</style>